import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import InfoPage from '../InfoPage';
import './TravelerOnboarding.sass';

const TravelerOnboarding = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [step, setStep] = useState(1);
  const totalSteps = 3; // We can adjust this based on your needs

  useEffect(() => {
    // Get email from URL params or localStorage
    const urlEmail = searchParams.get('email');
    const storedEmail = localStorage.getItem('postaway_email');
    
    if (urlEmail) {
      setEmail(urlEmail);
      localStorage.setItem('postaway_email', urlEmail);
    } else if (storedEmail) {
      setEmail(storedEmail);
    } else {
      // If no email, redirect to signup
      navigate('/traveler-signup');
    }
  }, [searchParams, navigate]);

  const handleNext = () => {
    if (step < totalSteps) {
      setStep(step + 1);
    }
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleComplete = async () => {
    setLoading(true);
    try {
      // TODO: Save onboarding data to database
      
      // Navigate to traveler dashboard or itineraries
      navigate('/itineraries');
    } catch (error) {
      console.error('Error completing onboarding:', error);
      alert('Failed to complete onboarding. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const onboardingContent = (
    <div className="traveler-onboarding">
      <div className="traveler-onboarding__container">
        {/* Progress Bar */}
        <div className="traveler-onboarding__progress">
          <div className="progress-bar">
            <div 
              className="progress-bar__fill" 
              style={{ width: `${(step / totalSteps) * 100}%` }}
            />
          </div>
          <div className="progress-text">
            Step {step} of {totalSteps}
          </div>
        </div>

        {/* Welcome Header */}
        <div className="traveler-onboarding__header">
          <h1 className="traveler-onboarding__title">
            Welcome to Postaway!
          </h1>
          <p className="traveler-onboarding__subtitle">
            Let's personalize your travel experience
          </p>
        </div>

        {/* Form Content */}
        <div className="traveler-onboarding__form">
          {step === 1 && (
            <div className="form-step">
              <h2>Tell us about yourself</h2>
              <p>This helps us match you with the perfect travel experiences</p>
              
              {/* Step 1 form fields will go here */}
              <div className="form-placeholder">
                <p style={{ textAlign: 'center', color: '#999', padding: '40px' }}>
                  Step 1 content will be added here based on your requirements
                </p>
              </div>
            </div>
          )}

          {step === 2 && (
            <div className="form-step">
              <h2>Travel Preferences</h2>
              <p>What kind of experiences are you looking for?</p>
              
              {/* Step 2 form fields will go here */}
              <div className="form-placeholder">
                <p style={{ textAlign: 'center', color: '#999', padding: '40px' }}>
                  Step 2 content will be added here based on your requirements
                </p>
              </div>
            </div>
          )}

          {step === 3 && (
            <div className="form-step">
              <h2>Connect & Discover</h2>
              <p>Follow your favorite creators and destinations</p>
              
              {/* Step 3 form fields will go here */}
              <div className="form-placeholder">
                <p style={{ textAlign: 'center', color: '#999', padding: '40px' }}>
                  Step 3 content will be added here based on your requirements
                </p>
              </div>
            </div>
          )}
        </div>

        {/* Navigation Buttons */}
        <div className="traveler-onboarding__actions">
          {step > 1 && (
            <button 
              className="btn btn--secondary"
              onClick={handleBack}
              disabled={loading}
            >
              Back
            </button>
          )}
          
          {step < totalSteps ? (
            <button 
              className="btn btn--primary"
              onClick={handleNext}
              disabled={loading}
            >
              Next
            </button>
          ) : (
            <button 
              className="btn btn--primary"
              onClick={handleComplete}
              disabled={loading}
            >
              {loading ? 'Completing...' : 'Complete Setup'}
            </button>
          )}
        </div>

        {/* Skip Option */}
        <div className="traveler-onboarding__skip">
          <button 
            className="skip-link"
            onClick={() => navigate('/itineraries')}
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <InfoPage
      title="Traveler Onboarding"
      belowHeader={onboardingContent}
      tallOverride={false}
      customMinHeight={800}
      disableStamps={false}
    />
  );
};

export default TravelerOnboarding;


